module.exports = __webpack_public_path__ + "img/member_trading_record_icon_431005.570bde31.png";